import React, { useEffect } from 'react'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// import cardpicture from '../../assets/Images/bg imm.png'
import '../../../assets/styles/pages/homeCss/testimonials.css'
import { Container } from 'react-bootstrap';
// import Card from 'react-bootstrap/Card';
import spl from '../../../assets/images/homeImages/unsplash_j5almO1E8rU.png'
import AOS from 'aos';

const Testimonials = () => {

  useEffect(() => {
    AOS.init({ duration: 2000, },);
  }, [])

  const sliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '0px',
    pauseOnHover: false,
    dots: true,
    infinite: true,
    vertical: false,
    verticalSwiping: false,

    beforeChange: function (currentSlide, nextSlide) {
    },
    afterChange: function (currentSlide) {
    },

  }
  return (
    <>
      <section className='testim-main' data-aos='fade-up'>
        <h1 className='text-center texthead'>Our Clients Love Us As<br /> Much As We Love Them</h1>
        <Slider {...sliderSettings}>
          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>

                      I wanted to say a few words about the impact that the Zen Warrior program had on me. From the very first day, the Oxyzn platform was straightforward and quite easy to use through the groups and the calendar which provides a great variety of options daily. The instructor made us all feel very welcome and at ease during the classes and provided great support to all the ladies who attended the Zen Warrior Programme. couldn’t recommend the Zen Warrior Programme and the Oxyzn platform enough, we all felt the difference in ourselves from the very first week of the program and I’m so happy I attended it!
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='p-3 text-center'>
                          <h2>Nina Dova</h2>
                          <h5>Career Coach</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>

          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>

                      It is an amazing platform and very useful! It helps me to stay connected with members of my group every time via posts, I had the opportunity to chat with my instructor - immediately when I need it! I loved the daily task from the calendar 📅, cause I had all the necessary information every day for my lessons! I love it, you can understand me when you will be a part of it!
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Stefi Kontopoulou</h2>
                          {/* <h5>HR Specialist</h5> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>

          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>

                      Oxyzn is an inspiring platform! I was part of the morning Miracle 20days challenge and it has been a very deep and transformational experience for me. Thank you to the oxyzn team for the support and amazing work.
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Areti Varvaresou</h2>
                          {/* <h5>HR Specialist</h5> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>

          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>
                      I'll rate the platform 4 to 5 stars, it has many choices and was easy to navigate. So many things to do from meditation, yoga, and exercise! All from the convenience of your own home.
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Evi Soukara</h2>
                          {/* <h5>HR Specialist</h5> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>

          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>
                    Let me share a heartwarming experience I had at one of Oxyzn's meditation taster session which I came across at the CIPD festival of work- it was truly extraordinary! This session became a haven of tranquillity, melting away the stress from my day of socialising. The guided meditation took us an incredible on journey of relaxation and inner peace. I can't praise this session enough, and wholeheartedly recommend it to anyone seeking a deeply human and soulful well-being experience. Oxyzn truly has a magical way of nurturing the spirit and leaving you feeling refreshed and uplifted
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Zoe Streat</h2>
                          <h5>Account Executive</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>
                    I joined Oxyzn session yesterday and it was fabulous. I have done Yoga Nidra before but this session was great. Especially amongst all the hustle and bustle of the festival. Oxyzn team did a fabulous job
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Kirsty Harper</h2>
                          <h5>Resourcing Manager at Barratt Developments</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>
                    I spotted Oxyzn session on the agenda I was drawn to box breathing and this is why I came at CIPD. I realised when we were doing it that I can't do box breathing properly and so I need to work on that. I really liked Oxyzn session, Thanks and good luck!
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Michalina Buenk</h2>
                          <h5>Employee Relations Consultant at Adobe</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <div>
            <div className='testimonial_'>
              <Container>
                <div className="testimonial-card">
                  <div>
                    <p className='text-center'>
                    I am a little way into my mindfulness journey now and have been looking to advance outside of the Calm and Headspace apps. I recently attended one of Oxyzn workshops with some of my colleagues who are new to mindfulness. The experience was great on all levels. We were made to feel really welcome. The atmosphere was very warm and we relaxed very quickly. After the session we all felt totally refreshed and really clear headed
                    </p>
                    {/* <h2>Nina Dova  
                   </h2> */}
                    <div className='review-profi'>
                      <div className='d-flex justify-content-center '>
                        <div className='text-center p-3'>
                          <h2>Katie Lamond</h2>
                          <h5>Head of Social Media at Vooba</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>
            </div>
          </div>
        </Slider>
      </section>
    </>
  )
}
export default Testimonials




